import { Grid } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import React from 'react'

import { useEconomicsContext } from '@/contexts/EconomicsContext'

import RewardsRecipients from './RewardsRecipients'
import YourStaking from './YourStaking'

const Staking: React.FC = () => {
  const { started } = useEconomicsContext()
  const isSmallScreen = useMediaQuery('(max-width: 1000px)')

  return (
    <Grid gutter="30px">
      <Grid.Col span={{ xs: 12, sm: 12, md: isSmallScreen ? 12 : 6, lg: 6 }}>
        <YourStaking />
      </Grid.Col>
      {started && (
        <Grid.Col span={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
          <RewardsRecipients />
        </Grid.Col>
      )}
    </Grid>
  )
}

export default Staking
